import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'

import {
    REQUEST_PURCHASE_SCHEDULES,
    FETCH_PURCHASE_SCHEDULES_SUCCESS,
    FETCH_PURCHASE_SCHEDULES_FAILURE,
    SELECT_PURCHASE_SCHEDULE,
    RESET_CURRENT_PURCHASE_SCHEDULE,
    REQUEST_PURCHASE_SCHEDULE_DETAIL,
    FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS,
    FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE,
    REQUEST_CREATING_PURCHASE_SCHEDULE,
    CREATE_PURCHASE_SCHEDULE_SUCCESS,
    CREATE_PURCHASE_SCHEDULE_FAILURE,
    REQUEST_EDITING_PURCHASE_SCHEDULE,
    EDIT_PURCHASE_SCHEDULE_SUCCESS,
    EDIT_PURCHASE_SCHEDULE_FAILURE
} from './type'

import {
    PURCHASE_SCHEDULES_URL
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI } from './root_url';

export function fetchPurchaseSchedules() {
    return dispatch => {
        dispatch(requestPurchaseSchedules());
        return axios.get(PURCHASE_SCHEDULES_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
          .then(response => {
            dispatch(fetchPurchaseSchedulesSuccess(response));
          }, err => {
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
                return
              }
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(fetchPurchaseSchedulesFailure(err));
          });
    }
}

export function requestPurchaseSchedules() {
    return {
        type: REQUEST_PURCHASE_SCHEDULES,
    };
}

export function fetchPurchaseSchedulesSuccess(purchaseSchedules) {
    return {
        type: FETCH_PURCHASE_SCHEDULES_SUCCESS,
        payload: purchaseSchedules
    };
}

export function fetchPurchaseSchedulesFailure(error) {
    return {
        type: FETCH_PURCHASE_SCHEDULES_FAILURE,
        payload: error
    };
}


export function selectPurchaseSchedule(purchaseSchedule) {
    return {
        type: SELECT_PURCHASE_SCHEDULE,
        payload: purchaseSchedule
    };
}


export function resetCurrentPurchaseSchedule() {
    return {
        type: RESET_CURRENT_PURCHASE_SCHEDULE
    }
}

// Fetch the detail page.

export function fetchPurchaseScheduleDetail(customer_id) {
    return dispatch => {
        dispatch(requestPurchaseScheduleDetail());
        return axios.get(PURCHASE_SCHEDULES_URL + customer_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
          .then(response => {
            dispatch(fetchPurchaseScheduleDetailSuccess(response));
          }, err => {
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
                return
              }
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(fetchPurchaseScheduleDetailFailure(err));
          });
    }
}

export function requestPurchaseScheduleDetail() {
    return {
        type: REQUEST_PURCHASE_SCHEDULE_DETAIL,
    };
}

export function fetchPurchaseScheduleDetailSuccess(purchaseScheduleDetail) {
    purchaseScheduleDetail = purchaseScheduleDetail.data;
    // The date data fetched is in the form of string, which needs to be modified into Date type
    if (purchaseScheduleDetail.StartDate) purchaseScheduleDetail.StartDate = new Date(purchaseScheduleDetail.StartDate);
    if (purchaseScheduleDetail.NextExecuteDate) purchaseScheduleDetail.NextExecuteDate = new Date(purchaseScheduleDetail.NextExecuteDate);
    return {
        type: FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS,
        payload: purchaseScheduleDetail
    };
}

export function fetchPurchaseScheduleDetailFailure(error) {
    return {
        type: FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE,
        payload: error
    };
}

export function createPurchaseSchedule({
    Name,
    Description,
    StartDate,
    RepeatFrequency,
    RepeatInterval,
    OneTimeDate,
    NextExecuteDate,
    IsEnabled,
    PurchaseTemplate
}) {
    if (RepeatFrequency) RepeatFrequency = RepeatFrequency.value || RepeatFrequency;
    if (typeof RepeatInterval !== 'undefined') {
      if(typeof RepeatInterval.value !== 'undefined')
        RepeatInterval = RepeatInterval.value;
    }
    if (StartDate) {
        var year = StartDate.getFullYear();
        var month = StartDate.getMonth() + 1;
        var day = StartDate.getDate();
        var hours = StartDate.getHours();
        var minutes = StartDate.getMinutes();
        var seconds = StartDate.getSeconds();
        StartDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
    }
    return dispatch => {
        dispatch({ type: REQUEST_CREATING_PURCHASE_SCHEDULE });
        axios.post(PURCHASE_SCHEDULES_URL,
            {
                Name,
                Description,
                StartDate,
                RepeatFrequency,
                RepeatInterval,
                OneTimeDate,
                NextExecuteDate,
                IsEnabled,
                PurchaseTemplate_id: PurchaseTemplate.PurchaseTemplate_id
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createPurchaseScheduleSuccess());
              browserHistory.push('/purchaseSchedule');
            }, err => {
                if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                    document.getElementById('tokenInvalid').style.display = 'flex'
                    return
                  }
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(createPurchaseScheduleFailure(err))
            });
    }
}

export function createPurchaseScheduleSuccess() {
    return {
        type: CREATE_PURCHASE_SCHEDULE_SUCCESS
    }
}

export function createPurchaseScheduleFailure(error) {
    return {
        type: CREATE_PURCHASE_SCHEDULE_FAILURE,
        payload: error
    }
}

export function editPurchaseSchedule({
    PurchaseSchedule_id,
    Name,
    Description,
    StartDate,
    RepeatFrequency,
    RepeatInterval,
    OneTimeDate,
    NextExecuteDate,
    IsEnabled,
    PurchaseTemplate
}) {
    if (RepeatFrequency) RepeatFrequency = RepeatFrequency.value || RepeatFrequency;
    if (RepeatInterval.value === 0 ) RepeatInterval = 0;
    else if (RepeatInterval) RepeatInterval = RepeatInterval.value || RepeatInterval;
    if (StartDate) {
        var year = StartDate.getFullYear();
        var month = StartDate.getMonth() + 1;
        var day = StartDate.getDate();
        var hours = StartDate.getHours();
        var minutes = StartDate.getMinutes();
        var seconds = StartDate.getSeconds();
        StartDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
    }
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_PURCHASE_SCHEDULE });
        axios.put((PURCHASE_SCHEDULES_URL + PurchaseSchedule_id),
            {
                Name,
                Description,
                StartDate,
                RepeatFrequency,
                RepeatInterval,
                OneTimeDate,
                NextExecuteDate,
                IsEnabled,
                PurchaseTemplate_id: PurchaseTemplate.PurchaseTemplate_id
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
          .then(response => {
            dispatch(editPurchaseScheduleSuccess());
            browserHistory.push('/purchaseSchedule'); // If editd succesfully, refresh the paymentTerm page.
          }, err => {
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
              return
            }
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(editPurchaseScheduleFailure(err));
          });
    }
}

export function editPurchaseScheduleSuccess() {
    return {
        type: EDIT_PURCHASE_SCHEDULE_SUCCESS
    }
}

export function editPurchaseScheduleFailure(error) {
    return {
        type: EDIT_PURCHASE_SCHEDULE_FAILURE,
        payload: error
    }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/purchaseSchedules_actions.js